/**
 * VuePrint v1.6.3
 * Copyright (c) 2024 Jak Guru LLC
 * Vueprint a commerical work product released under the MIT License
 * and is provided as-is with no warranty or guarantee of support.
 * Documentation: https://jakguru.github.io/vueprint/
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import 'webfontloader';
import { ref } from 'vue';
import { g as getDebugger } from '../shared/@jakguru/vueprint.b84f56b4.mjs';
import '../shared/@jakguru/vueprint.73231624.mjs';
import 'bowser';

const debug = getDebugger("Webfontloader");
const WebfontloaderPlugin = {
  install: (app, options) => {
    const installed = ref(false);
    if (installed.value === false && options && (options.custom || options.google || options.typekit || options.fontdeck || options.monotype)) {
      const onLoading = () => {
        if (options && options.loading && "function" === typeof options.loading) {
          options.loading();
        }
        if (app.config.globalProperties.$bus) {
          app.config.globalProperties.$bus.emit("webfonts:loading", { local: true });
        }
        debug("Webfonts loading");
      };
      const onActive = () => {
        if (options && options.active && "function" === typeof options.active) {
          options.active();
        }
        if (app.config.globalProperties.$bus) {
          app.config.globalProperties.$bus.emit("webfonts:active", { local: true });
        }
        debug("Webfonts active");
      };
      const onInactive = () => {
        if (options && options.inactive && "function" === typeof options.inactive) {
          options.inactive();
        }
        if (app.config.globalProperties.$bus) {
          app.config.globalProperties.$bus.emit("webfonts:inactive", { local: true });
        }
        debug("Webfonts inactive");
      };
      if ("undefined" !== typeof window && "undefined" !== typeof window.WebFont) {
        try {
          window.WebFont.load({
            ...options,
            loading: onLoading,
            active: onActive,
            inactive: onInactive
          });
          installed.value = true;
        } catch (error) {
          debug("Error loading webfonts", error);
        }
      } else if ("undefined" === typeof window.WebFont) {
        debug("WebFont not loaded in global scope");
      }
    } else if (installed.value === false) {
      debug("No webfonts to load");
    }
  }
};

export { WebfontloaderPlugin };
//# sourceMappingURL=webfontloader.mjs.map
